<template>
  <div class="">
    <div
      class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8 bg-white rounded-t-2xl rounded-br-2xl border-vectric border-4 mt-10"
    >
      <div class="lg:grid lg:grid-cols-3 lg:gap-8">
        <div>
          <h2 class="text-3xl font-extrabold text-darkBlue">
            Frequently asked questions
          </h2>
          <p class="mt-4 text-lg text-gray-500">
            Can’t find the answer you’re looking for? Reach out to our
            <a
              href="mailto:support@vectric.com"
              class="font-medium text-darkBlue hover:text-vectric"
            >
              support</a
            >
            team. Or ask a question in the
            <router-link
              to="/social"
              class="font-medium text-darkBlue hover:text-vectric"
            >
              chat
            </router-link>
          </p>
        </div>
        <div class="mt-12 lg:mt-0 lg:col-span-2">
          <dl class="space-y-12">
            <div v-for="question in questions" :key="question._key">
              <div class="text-lg leading-6 font-semibold text-darkblue">
                {{ question.question }}
              </div>
              <div class="mt-2 text-base text-gray-500 prose">
                <block-content
                  :blocks="question.answer"
                  :serializers="serializers"
                ></block-content>
              </div>
            </div>

            <!-- More questions... -->
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sanityClient } from "../utils/sanity";
import RichText50Image from "../components/RichText50Image";
import RichTextGallery from "../components/RichTextGallery";
import BlockContent from "sanity-blocks-vue-component";

export default {
  name: "Faqs",
  components: {
    BlockContent
  },
  data() {
    return {
      questions: [],
      serializers: {
        types: {
          image: RichText50Image,
          gallery: RichTextGallery
        }
      }
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const queryString = "*[_id == 'faqs'][0] {...}";
      sanityClient
        .fetch(queryString)
        .then(res => {
          console.log(res);
          this.questions = res.questions;
        })
        .catch(function(err) {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped></style>
